import { WGCWX_SHOP_CLAN_INFO_LOADED } from 'state/actions/wgcwx_shop'

const initialState = {
    loaded: false,
    clan_info: {
        tag: '',
        joined_at: 0,
        id: 0,
        full_name: '[] ',
        name: '',
    },
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case WGCWX_SHOP_CLAN_INFO_LOADED:
        return {
            ...state,
            loaded: true,
            clan_info: action.payload.clan_info,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_shop/clan.js